import { createSelector } from 'reselect';

import options from './options';

const { name } = options;

export const curInterpretation = state => state.models[name].data;
export const curInterpretations = state => state.models[name].list;
export const isInterpretationLoading = state => state.models[name].loading;
